import React, { Component } from 'react';
import styled from 'styled-components'

const Wrapper = styled.div`
  max-width: 80vw;
  width: 80vw;
  margin: 0 auto;
  height: auto;
  overflow: auto;
  padding: 0.5rem 0;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
  ::-webkit-scrollbar {
    display: none;
  }
`

class Calendly extends Component {
  componentDidMount() {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.setAttribute('src',  'https://assets.calendly.com/assets/external/widget.js');
    head.appendChild(script);
  }

  componentWillUnmount() {
    // whatever you need to cleanup the widgets code
  }

  render(){
    return (
      <Wrapper
      >
        <div id="schedule_form" title = "Book an Appointment" >
          <div
            className="calendly-inline-widget"
            data-url="https://calendly.com/sfuggi25/30min"
            style={{ minWidth: '240px', height: '800px' }} />
        </div>
      </Wrapper>
    );
  }
}


export default Calendly
